"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipWrapper = exports.TooltipPayloadWrapper = exports.ItemNameGroup = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const TooltipWrapper = exports.TooltipWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1xnunu72"
} : {
  target: "e1xnunu72",
  label: "TooltipWrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;flex-direction:column;background-color:white;padding:1rem;box-shadow:", props?.theme && props.theme.shadowBig, ";border-radius:4px;>span:first-of-type{margin-bottom:5px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:TooltipWrapper;")));
const TooltipPayloadWrapper = exports.TooltipPayloadWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1xnunu71"
} : {
  target: "e1xnunu71",
  label: "TooltipPayloadWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1y1bc9v",
  styles: "display:flex;justify-content:space-between;align-items:center;width:100%;>:first-of-type{margin-right:0.5em;}"
} : {
  name: "1y1bc9v",
  styles: "display:flex;justify-content:space-between;align-items:center;width:100%;>:first-of-type{margin-right:0.5em;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ItemNameGroup = exports.ItemNameGroup = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1xnunu70"
} : {
  target: "e1xnunu70",
  label: "ItemNameGroup"
})(process.env.NODE_ENV === "production" ? {
  name: "zmujkq",
  styles: "display:flex;align-items:center;>:first-of-type{margin-right:5px;}"
} : {
  name: "zmujkq",
  styles: "display:flex;align-items:center;>:first-of-type{margin-right:5px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});